<a href="#maincontent" class="skip-link">{{skipToMainContentLabel}}</a>
@if (!inUpliftTheme) {
  <soho-icons></soho-icons>
}
@if (inUpliftTheme) {
  <soho-icons-uplift></soho-icons-uplift>
}
@if (!inUpliftTheme) {
  <soho-icons-empty></soho-icons-empty>
}
@if (inUpliftTheme) {
  <soho-icons-empty-new></soho-icons-empty-new>
}

<soho-module-nav-container [ngClass]="{'module-nav-container': !hideAppMenu}" data-automation-id="lm-appmenu-application-menu">
    @if (!hideAppMenu && webAppsLoaded) {
      <soho-module-nav
        #SohoModuleNav
        [ngClass]="{ 'module-nav': true }"
        [showGuestSection]="!mingleMode && !inNativeMobileApp"
        [displayMode]="moduleNavDisplayMode"
        [filterable]="false"
        [pinSections]="true"
        (displaymodechange)="handleDisplayModeChange($event)"
      >
        <lm-application-menu-v3
          class="module-nav-bar"
          [moduleNavDisplayMode]="moduleNavDisplayMode"
          [asOfDate]="asOfDate"
          [searchString]="searchString"
          [menuSearchMode]="menuSearchMode"
          [menuSpecsByWebApp]="menuSpecsByWebApp"
          [dataSearchResults]="dataSearchResults"
          [reportSearchResults]="reportSearchResults"
          (webAppMenuLoaded)="onWebAppMenuLoaded()"
          (menuLoaded)="onMenuLoaded($event)"
          (menuSearched)="onMenuSearched($event)"
          (asOfDateChanged)="onAsOfDateChanged($event)"
          (asOfDateClearedEvent)="onAsOfDateCleared()"
          (menuSearchCleared)="onMenuSearchCleared()"
          (roleSelected)="roleSelected()"
          (sohoModuleNavExpanded)="onExpandSohoModuleNav()"
          (sohoModuleNavCollapsed)="onCollapseSohoModuleNav()"
          (homeClicked)="onHomeClicked()">
        </lm-application-menu-v3>
      </soho-module-nav>
    }
    <!--
    - margin-top - of 60px in maincontent is causing issues when showing th busy indicator. It's causing
      shifting when displaying a formComponent (specifically JobPosting.PostingDisplay). Hard coding to 0px.

    - text - Set to a literal 1 space char so that the default text of the busy indicator won't display.
    - displayDelay - default and minimum is 20 ms.
    - blockUI - set to true to stop input while the busy indicator is active
    - timeToComplete - the maximum amount of time the indicator is up. useful for when the busyindicator.close doesn't
                       get messaged due to an error or something.
    - transparentOverlay - whether or not to display a fully transparent overlay instead of the standard grey semi-transparent overlay.
    - complete - event that is fired when the timeToComplete is done; fires regardless if busyIndicator is programmatically stopped
    -->
    <div soho-busyindicator
      #fullmaincontent
      id="fullmaincontent"
      [ngClass]="{
        'page-container': true,
        'scrollable': useFullPageScrolling,
        'lm-hide-titlebar': hideTitle,
        'viewMoreNav' : showViewMoreNav,
      }"
      [text]="' '"
      [blockUI]="true"
      [displayDelay]="0"
      [transparentOverlay]="true"
      [style.margin-top]="'0px'"
      [timeToComplete]="this.uiLoadingIndicatorTimeout"
      (complete)="onBusyComplete($event)"
    >
      @if (!inMingleWidget && !inMingleInbox && !hideTitle && !bannerInRoute) {
        <lm-banner-header
          role="banner"
          [class.lm-sticky-banner]="true"
          (appMenuTriggerEvent)="onAppMenuTriggerEvent()"
          (hasBreadcrumbEvent)="onHasBreadcrumbs($event)"
          (asOfDateChanged)="onAsOfDateChanged($event)"
          (asOfDateCleared)="onAsOfDateCleared()"
          (useFullPageScrolling)="fullPageScrolling($event)"
          [asOfDate]="asOfDate"
          [showArchive]="showArchive"
          (quitArchiveViewEvent)="onQuitArchiveView()"
          (quitProxyModeEvent)="onQuitProxyMode()"
          (quitDBSessionDebugModeEvent)="onQuitDBSessionDebugMode()"
          (quitListCostReportModeEvent)="onQuitListCostReportMode()"
          (quitSecSessionDebugModeEvent)="onQuitSecSessionDebugMode()">
        </lm-banner-header>
      }

      @if (webAppsLoaded) {
        <div #maincontent
          id="maincontent"
          [ngStyle]="{ 'height': onMobile ? 'calc(100% - 50px)' : !inMingleWidget && !inMingleInbox && !hideTitle && !bannerInRoute ? hasHeaderTabs || hasBreadcrumbs ? 'calc(100% - 105px)' : 'calc(100% - 61px)' : '100%' }"
        >
          <router-outlet (activate)="onActivate()" (detach)="onOutletDetach($event)" (attach)="onOutletAttach($event)"></router-outlet>
        </div>
      }
    </div>

    <lm-sidebar-resize [ngStyle]="{'display': showFormOverlay ? null : 'none'}"></lm-sidebar-resize>
    <span lm-live-region [liveRegionConfig]="liveMessage"></span>
</soho-module-nav-container>

<ng-template #MainContent>
  <!--
    - margin-top - of 60px in maincontent is causing issues when showing th busy indicator. It's causing
      shifting when displaying a formComponent (specifically JobPosting.PostingDisplay). Hard coding to 0px.

    - text - Set to a literal 1 space char so that the default text of the busy indicator won't display.
    - displayDelay - default and minimum is 20 ms.
    - blockUI - set to true to stop input while the busy indicator is active
    - timeToComplete - the maximum amount of time the indicator is up. useful for when the busyindicator.close doesn't
                       get messaged due to an error or something.
    - transparentOverlay - whether or not to display a fully transparent overlay instead of the standard grey semi-transparent overlay.
    - complete - event that is fired when the timeToComplete is done; fires regardless if busyIndicator is programmatically stopped
    -->
  <div soho-busyindicator
       #fullmaincontent
       id="fullmaincontent"
       [ngClass]="{
          'page-container': true,
          'scrollable': useFullPageScrolling,
          'lm-hide-titlebar': hideTitle,
          'viewMoreNav' : showViewMoreNav,
       }"
       [text]="' '"
       [blockUI]="true"
       [displayDelay]="0"
       [transparentOverlay]="true"
       [style.margin-top]="'0px'"
       [timeToComplete]="this.uiLoadingIndicatorTimeout"
       (complete)="onBusyComplete($event)"
  >
    @if (!inMingleWidget && !inMingleInbox && !hideTitle && !bannerInRoute && !drillAroundWindow) {
      <lm-banner-header
        role="banner"
        [class.lm-sticky-banner]="true"
        (appMenuTriggerEvent)="onAppMenuTriggerEvent()"
        (hasBreadcrumbEvent)="onHasBreadcrumbs($event)"
        (asOfDateChanged)="onAsOfDateChanged($event)"
        (asOfDateCleared)="onAsOfDateCleared()"
        (useFullPageScrolling)="fullPageScrolling($event)"
        [asOfDate]="asOfDate"
        [showArchive]="showArchive"
        (quitArchiveViewEvent)="onQuitArchiveView()"
        (quitProxyModeEvent)="onQuitProxyMode()"
        (quitDBSessionDebugModeEvent)="onQuitDBSessionDebugMode()"
        (quitSecSessionDebugModeEvent)="onQuitSecSessionDebugMode()">
      </lm-banner-header>
    }

    @if (webAppsLoaded) {
      <div #maincontent
        id="maincontent"
        [ngStyle]="{'height': onMobile ? 'calc(100% - 50px)' : !inMingleWidget && !inMingleInbox && !hideTitle && !bannerInRoute ? hasHeaderTabs || hasBreadcrumbs ? 'calc(100% - 105px)' : 'calc(100% - 61px)' : '100%' }"
      >
        <router-outlet (activate)="onActivate()" (detach)="onOutletDetach($event)" (attach)="onOutletAttach($event)"></router-outlet>
      </div>
    }

  </div>
</ng-template>

<!-- MINGLE VIEW MORE -->
@if (showViewMoreNav) {
  <lm-view-more></lm-view-more>
}

<div #dialogPlaceholder id="lmAppComponentDialogPlaceholder" class="lmDialogPlaceholder"></div>
